import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const LeftBar = styled(Flex).attrs({
  width: '35%',
  height: '100%',
  padding: '30px',
  column: true,
})`
  background-color: ${props => props.theme.colors.baseBanner};
`;

export const FormBar = styled(Flex).attrs({
  height: '100%',
  width: '65%',
  padding: '30px',
  scrollY: 'visible',
})`
`;

export const ResetTutorial = styled(Text).attrs({
  size: '18px',
  color: '#fff',
  weight: 500,
})`
  cursor: pointer;
`;

export const BirthPicker = styled(Flex).attrs({
  width: '100%',
  column: true,
})`
  & > div {
    width: 100%;
  }
`;

export const TimezonePicker = styled(Flex).attrs({
  width: '100%',
  column: true,
})`
  & > div {
    width: 45%;
  }
`;

export const Back = styled(Button).attrs({
  icon: 'fa fa-chevron-left',
  appearance: 'link',
})`
  color: #fff !important;
  font-size: 18px;
  font-weight: 500;
`;
